<template>
  <ItemRow>
    <ItemWithLabel
      v-for="(column, index) in columns"
      :key="index"
      :class="[$style.item, `${$style.item}--${column.dataFieldName}`]"
      :column="column"
    >
      {{ metadata[column.dataFieldName].getDataValue(itemData) }}
      <template v-if="isStatusColumn(column.dataFieldName)">
        <br>
        <Link
          :class="$style.detailsButton"
          data-test-id="InvoicesItemRow__viewDetails"
          :href="getInvoiceUrl(itemData.id)"
          target="_blank"
          text="View Details"
        />
      </template>
    </ItemWithLabel>
  </ItemRow>
</template>

<script>
import {
  ItemRow,
  ItemWithLabel,
  Link,
} from '@jumpcloud/ui-components';
import { invoiceMetadata, invoiceProperties } from 'client/Account/InvoicesPage/InvoiceAttributesConsts';
import OrganizationInvoiceApi from 'client/api/v2/OrganizationInvoiceApi';

export default {
  name: 'InvoicesItemRow',

  components: {
    ItemRow,
    ItemWithLabel,
    Link,
  },

  props: {
    columns: {
      type: Array,
      default: () => ([]),
    },

    itemData: {
      required: true,
      type: Object,
    },
  },

  created() {
    this.metadata = invoiceMetadata;
  },

  methods: {
    getInvoiceUrl: OrganizationInvoiceApi.getInvoiceUrl,

    isStatusColumn(fieldName) {
      return fieldName === invoiceProperties.status;
    },
  },
};
</script>

<style module>
.item {
  font-weight: 600;
}

.item--dueDate {
  font-weight: bold;
}

.detailsButton {
  --button-font-size: var(--jcBodySmall);
}

.detailsButton span {
  font-weight: normal;
}
</style>
